import { render } from "./md-contrast.vue?vue&type=template&id=73684b8e"
import script from "./md-contrast.vue?vue&type=script&lang=js"
export * from "./md-contrast.vue?vue&type=script&lang=js"
script.render = render

export default script